import { api } from '../../lib/api';

export type StockTakeStatus = 'DRAFT' | 'COUNTED' | 'APPLIED' | 'CANCELLED';

export interface StockTakeLineDTO {
  id: number;
  productId: number;
  expectedQty: string;
  countedQty: string | null;
  note: string | null;
  product: { sku: string; name: string };
}

export interface StockTakeDTO {
  id: number;
  warehouseId: number;
  status: StockTakeStatus;
  notes: string | null;
  createdAt: string;
  appliedAt: string | null;
  lines: StockTakeLineDTO[];
}

export interface StockTakeSummaryDTO {
  id: number;
  warehouseId: number;
  status: StockTakeStatus;
  createdAt: string;
  appliedAt: string | null;
  _count: { lines: number };
}

export async function listStockTakes(): Promise<StockTakeSummaryDTO[]> {
  const { data } = await api.get<StockTakeSummaryDTO[]>('/api/stock-takes');
  return data;
}

export async function getStockTake(id: number): Promise<StockTakeDTO> {
  const { data } = await api.get<StockTakeDTO>(`/api/stock-takes/${id}`);
  return data;
}

export async function openStockTake(warehouseId: number): Promise<StockTakeDTO> {
  const { data } = await api.post<StockTakeDTO>('/api/stock-takes', { warehouseId });
  return data;
}

export async function setLineCount(
  takeId: number,
  body: { productId: number; countedQty: number; note?: string },
): Promise<StockTakeLineDTO> {
  const { data } = await api.post<StockTakeLineDTO>(`/api/stock-takes/${takeId}/count`, body);
  return data;
}

export async function markCounted(takeId: number): Promise<StockTakeDTO> {
  const { data } = await api.post<StockTakeDTO>(`/api/stock-takes/${takeId}/mark-counted`);
  return data;
}

export async function applyStockTake(takeId: number): Promise<{ adjustedLines: number }> {
  const { data } = await api.post<{ adjustedLines: number }>(`/api/stock-takes/${takeId}/apply`);
  return data;
}

export async function cancelStockTake(takeId: number): Promise<void> {
  await api.post(`/api/stock-takes/${takeId}/cancel`);
}
